import Vue from 'vue';

const refreshToken = () => {
    // 憑證失效須執行此 function 取得新的憑證
    return request({
        method: 'POST',
        api: '/api/refreshToken',
        secure: true,
    })
        .then(res => {
            // if has cookies set token
            Vue.$cookies.set('token', res.data.jwt);
            return res.data;
        }).catch(() => {
            return null;
        });
};

/**
 * API Request
 * @param {string} method - POST, GET, PUT, DELETE ...
 * @param {string} api - 目標 url
 * @param {bolean} secure - 是否需要安全性
 * @param {bolean} base - 是否為基礎環境, 說明如下
 * ex:
 *  現在Project default base url 為 /fubonagent/reserve
 *  但有些操作要在 /fubonagent 進行, 此為判斷使用哪個區域之變數
 */
export const request = ({ method, api, data, secure, base }) => {
    const token = Vue.$cookies.get('token');
    const headers = secure ? {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
    } : { 'Content-Type': 'application/json' };

    // 攔截器 initial setting
    const instance = Vue.axios.create({
        baseURL: base ? process.env.VUE_APP_BASE_HOST : process.env.VUE_APP_HOST, // 操作網頁路徑
        headers: headers, // request headers config
        timeout: 20000,
    });

    // 攔截器攔截後端系統response操作
    instance.interceptors.response.use(
        (response) => { return response; },
        async (error) => {
            let newRequest;
            let errorStatus;
            if (error.response) {
                if (error.response.status === 401) {
                    if (api === '/api/refreshToken' || api === '/api/share/check/cookie') {
                        errorStatus = { status: 401, message: '欲預約專人服務, 邀請你到富邦人壽「找出你的最佳保障方案」' };
                    } else {
                        const newToken = await refreshToken();
                        if (newToken) {
                            newRequest = await request({ method, api, data, secure });
                        } else {
                            errorStatus = { status: 401, message: '欲預約專人服務, 邀請你到富邦人壽「找出你的最佳保障方案」' };
                        }
                    }
                } else {
                    errorStatus = { status: error.response.status, message: '程式發生問題' };
                }
            }

            // promise 結果不符與程式錯誤返回數據
            return Promise.reject(newRequest || errorStatus || error);
        }
    );

    // 操作 client request promise
    return instance.request({
        method: method,
        url: api,
        data: data,
        headers: headers,
    }).then((response) => {
        // 操作各個狀態返回對應之狀態碼、正確資訊、錯誤訊息
        // 錯誤碼請利用 throw expression 拋出錯誤相關資料, 資料將會進入 catch 區塊
        if (response.data.status === 500) {
            throw {
                message: response.data.errorMsg,
                status: 500
            };
        } else if (response.data.status === 400) {
            throw {
                data: response.data.response,
                status: 400
            };
        } else {
            return {
                data: response.data.response,
                status: 200
            };
        }
    }).catch(error => {
        // 因會遇到第一次錯誤, 第二次成功去做 refreshToken 操作
        // 要判斷第二次操作的狀態, 如為成功一般返回資訊即可, 若為失敗請使用 throw expression 拋出錯誤相關資料
        if (error.status === 200) {
            return error;
        } else {
            throw error;
        }
    });
};
